import {
  openTrailEditToolbar as diToolingOpenEditToolbar,
  closeTrailEditToolbar as diToolingCloseEditToolbar,
  DiToolingState
} from '@alltrails/di-tooling';
import { useDispatch, useSelector } from '@/utils/redux';

export default function useTrailEditToolbar() {
  const dispatch = useDispatch();
  const diTooling = useSelector(state => state.diTooling);

  const openTrailEditToolbar = (toolbarSection?: DiToolingState['trailEditToolbarFocusSection']) =>
    dispatch(diToolingOpenEditToolbar(toolbarSection));
  const closeTrailEditToolbar = () => dispatch(diToolingCloseEditToolbar());

  return {
    showTrailEditToolbar: diTooling?.showTrailEditToolbar,
    trailEditToolbarFocusSection: diTooling?.trailEditToolbarFocusSection,
    openTrailEditToolbar,
    closeTrailEditToolbar
  };
}
